import { type Group } from "./types";

export const GROUPS: Group[] = [
  {
    name: "format",
    title: "Formato",
    commands: [
      // {
      // 	name: 'heading1',
      // 	label: 'Título 1',
      // 	iconName: 'lucide-heading-1',
      // 	description: 'High priority section title',
      // 	aliases: ['h1'],
      // 	action: (editor) => {
      // 		editor.chain().focus().setHeading({ level: 1 }).run()
      // 	},
      // },
      {
        name: "heading2",
        label: "Título 2",
        iconName: "lucide-heading-2",
        description: "Medium priority section title",
        aliases: ["h2"],
        action: (editor) => {
          editor.chain().focus().setHeading({ level: 2 }).run();
        },
      },
      {
        name: "heading3",
        label: "Título 3",
        iconName: "lucide-heading-3",
        description: "Low priority section title",
        aliases: ["h3"],
        action: (editor) => {
          editor.chain().focus().setHeading({ level: 3 }).run();
        },
      },
      {
        name: "bulletList",
        label: "Lista",
        iconName: "lucide-list",
        description: "Unordered list of items",
        aliases: ["ul"],
        action: (editor) => {
          editor.chain().focus().toggleBulletList().run();
        },
      },
      {
        name: "numberedList",
        label: "Lista numerada",
        iconName: "lucide-list-ordered",
        description: "Ordered list of items",
        aliases: ["ol"],
        action: (editor) => {
          editor.chain().focus().toggleOrderedList().run();
        },
      },
      {
        name: "blockquote",
        label: "Cita",
        iconName: "lucide-quote",
        description: "Element for quoting",
        action: (editor) => {
          editor.chain().focus().setBlockquote().run();
        },
      },
    ],
  },
  {
    name: "insert",
    title: "Insertar",
    commands: [
      // {
      // 	name: 'table',
      // 	label: 'Table',
      // 	iconName: 'lucide-table',
      // 	description: 'Insert a table',
      // 	shouldBeHidden: (editor) => editor.isActive('columns'),
      // 	action: (editor) => {
      // 		editor
      // 			.chain()
      // 			.focus()
      // 			.insertTable({ rows: 3, cols: 3, withHeaderRow: false })
      // 			.run()
      // 	},
      // },
      {
        name: "image",
        label: "Imagen",
        iconName: "lucide-image",
        description: "Inserta una imagen",
        aliases: ["img"],
        action: (editor) => {
          editor.chain().focus().setImageUpload().run();
        },
      },
      {
        name: "video",
        label: "Vídeo Youtube",
        iconName: "youtube",
        description: "Inserta un vídeo",
        aliases: ["vid", "youtube", "video"],
        action: (editor) => {
          editor.chain().focus().setYoutubePre().run();
        },
      },
      {
        name: "columns",
        label: "Columnas",
        iconName: "lucide-columns-2",
        description: "Añade dos columnas de contenido",
        aliases: ["cols"],
        shouldBeHidden: (editor) => editor.isActive("columns"),
        action: (editor) => {
          editor
            .chain()
            .focus()
            .setColumns()
            .focus(editor.state.selection.head - 1)
            .run();
        },
      },
      {
        name: "horizontalRule",
        label: "Separador",
        iconName: "lucide-separator-horizontal",
        description: "Inserta una línea horizontal para separar contenido",
        aliases: ["hr"],
        action: (editor) => {
          editor.chain().focus().setHorizontalRule().run();
        },
      },
    ],
  },
];

export default GROUPS;
